import React, { useEffect } from "react";
import { motion, useAnimate } from "framer-motion";

import pfp from "../../assets/images/pfp.png";
import react from "../../assets/images/react.png";
import aws from "../../assets/images/aws.png";
import firebase from "../../assets/images/firebase.png";

export default function IntroImage() {
  // Create the animate instance for the circle
  const [scope1, animate1] = useAnimate();
  const [scope2, animate2] = useAnimate();
  const [scope3, animate3] = useAnimate();

  // Handle the hover effect using useEffect
  useEffect(() => {
    const enterAnimation = () => {
      animate1(
        scope1.current,
        { opacity: 1, y: -50 },
        { type: "spring", stiffness: 50, mass: 0.5 }
      );
    };

    const leaveAnimation = () => {
      animate1(
        scope1.current,
        { opacity: 0, y: 0 },
        { type: "spring", stiffness: 50, mass: 0.5 }
      );
    };

    const imageElement = document.getElementById("image");

    imageElement.addEventListener("mouseenter", enterAnimation);
    imageElement.addEventListener("mouseleave", leaveAnimation);

    return () => {
      imageElement.removeEventListener("mouseenter", enterAnimation);
      imageElement.removeEventListener("mouseleave", leaveAnimation);
    };
  }, [animate1, scope1]);

  useEffect(() => {
    const enterAnimation = () => {
      animate2(
        scope2.current,
        { opacity: 1, y: -35, x: -100 },
        { type: "spring", stiffness: 50, mass: 0.5 }
      );
    };

    const leaveAnimation = () => {
      animate2(
        scope2.current,
        { opacity: 0, y: 0, x: 0 },
        { type: "spring", stiffness: 50, mass: 0.5 }
      );
    };

    const imageElement = document.getElementById("image");

    imageElement.addEventListener("mouseenter", enterAnimation);
    imageElement.addEventListener("mouseleave", leaveAnimation);

    return () => {
      imageElement.removeEventListener("mouseenter", enterAnimation);
      imageElement.removeEventListener("mouseleave", leaveAnimation);
    };
  }, [animate2, scope2]);

  useEffect(() => {
    const enterAnimation = () => {
      animate3(
        scope3.current,
        { opacity: 1, y: -35, x: 100 },
        { type: "spring", stiffness: 50, mass: 0.5 }
      );
    };

    const leaveAnimation = () => {
      animate3(
        scope3.current,
        { opacity: 0, y: 0, x: 0 },
        { type: "spring", stiffness: 50, mass: 0.5 }
      );
    };

    const imageElement = document.getElementById("image");

    imageElement.addEventListener("mouseenter", enterAnimation);
    imageElement.addEventListener("mouseleave", leaveAnimation);

    return () => {
      imageElement.removeEventListener("mouseenter", enterAnimation);
      imageElement.removeEventListener("mouseleave", leaveAnimation);
    };
  }, [animate3, scope3]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: "spring", stiffness: 70, damping: 20, delay: 0.8 }}
      className="relative flex justify-center items-center p-2"
    >
      {/* White circle that pops out of the top */}
      <motion.div
        ref={scope1}
        className="absolute top-[50px] w-16 h-16 rounded-full bg-white bg-opacity-50"
        initial={{ opacity: 0, y: 0 }} // Initially hidden
        style={{
          left: "calc(50% - 2rem)",
          backgroundImage: `url(${aws})`,
          backgroundSize: "80%", // Optional: to cover the entire div
          backgroundPosition: "center", // Optional: to center the image
          backgroundRepeat: "no-repeat",
          borderColor: "#3B82F6",
        }}
      />

      <motion.div
        ref={scope2}
        className="absolute top-[75px] w-16 h-16 rounded-full bg-white bg-opacity-50"
        initial={{ opacity: 0, y: 0 }} // Initially hidden
        style={{
          left: "calc(50% - 2rem)",
          backgroundImage: `url(${firebase})`,
          backgroundSize: "80%", // Optional: to cover the entire div
          backgroundPosition: "center", // Optional: to center the image
          backgroundRepeat: "no-repeat",
          borderColor: "#3B82F6",
        }}
      />

      <motion.div
        ref={scope3}
        className="absolute top-[75px] w-16 h-16 rounded-full bg-white bg-opacity-50"
        initial={{ opacity: 0, y: 0 }} // Initially hidden
        style={{
          left: "calc(50% - 2rem)",
          backgroundImage: `url(${react})`,
          backgroundSize: "80%", // Optional: to cover the entire div
          backgroundPosition: "center", // Optional: to center the image
          backgroundRepeat: "no-repeat",
          borderColor: "#3B82F6",
        }}
      />

      {/* Main profile image */}
      <motion.div
        id="image" // Add an ID to target the hover area
        className="relative w-[20vh] h-[20vh] md:w-64 md:h-64 rounded-full border-4 md:border-8" // Remove padding here to prevent the padding offset
        style={{
          backgroundImage: `url(${pfp})`,
          backgroundSize: "cover", // Optional: to cover the entire div
          backgroundPosition: "center", // Optional: to center the image
          borderColor: "rgb(96, 165, 250)",
        }}
        whileHover={{
          borderColor: "rgb(253, 224, 71)",
          scale: 0.85,
          y: 20, // Moves the image down when hovered
        }}
        transition={{ duration: 0.3 }} // Smooth transition duration
      />
    </motion.div>
  );
}
